export default `<div class="game-overlay">
    <div class="game-frame-wrapper">
        <div class="wh-preloader wh-preloader--center"></div>
        <p>Loading... Please wait</p>  
        <iframe class="game-iframe" src="<%= url %>"></iframe>
    </div>
    <div class="game-controls">
        <button class="game-minimize btn btn--transparent -float-right gaming-icon icon-x"></button>
    </div>
</div>`;